/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Fill_PathsInputs */

const vi_grower_area_camera_fill_paths = /** @type {(inputs: Grower_Area_Camera_Fill_PathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập token`)
};

/**

* @param {Grower_Area_Camera_Fill_PathsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_fill_paths = /** @type {((inputs?: Grower_Area_Camera_Fill_PathsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Fill_PathsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_fill_paths(inputs)
});